import React from 'react';
import { Muffin } from '@gamiphy/muffin';

export const ButtonMuffin = Muffin(React.lazy(() => import('./Button')));
